import { Api } from '../api';
import { misc } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { CountryResponse } from './models';

export class MiscApi extends Api {
  static getCountries = (signal?: AbortSignal) => this.get<ApiResponse<CountryResponse[]>>({ url: misc.getCountries(), signal });

  static getCurrencies = (signal?: AbortSignal) => this.get<ApiResponse<string[]>>({ url: misc.getCurrencies(), signal });

  static getAvailableCurrencies = (signal?: AbortSignal) => this.get<ApiResponse<string[]>>({ url: misc.getAvailableCurrencies(), signal });

  static getCountryProvinces = (signal?: AbortSignal) => this.get<ApiResponse<any>>({ url: misc.getCountryProvinces(), signal });

  static getTransferCurrencies = (signal?: AbortSignal) => this.get<ApiResponse<string[]>>({ url: misc.getTransferCurrencies(), signal });
}
